<p>assign-project-groups works!</p>
